export default __webpack_public_path__ + "static/media/Belt of Fiendish Invocation.7eb5eb99.jpg";